import { render, staticRenderFns } from "./PrimaryChildGuardians.vue?vue&type=template&id=7c334186"
import script from "./PrimaryChildGuardians.vue?vue&type=script&lang=js"
export * from "./PrimaryChildGuardians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports